export const STO_PRINT_TEMPLATE_ROUTE_ROOT = '/sto-template-print';

export const STO_PRINT_TEMPLATE_ROUTES = {
  PRINT: STO_PRINT_TEMPLATE_ROUTE_ROOT,
  SURAT_PESANAN: `${STO_PRINT_TEMPLATE_ROUTE_ROOT}/surat-pesanan`,
  INVOICE: `${STO_PRINT_TEMPLATE_ROUTE_ROOT}/invoice`,
} as const;
